import {FC} from 'react';
import {styled} from 'styled-components';
import {useParams} from 'wouter';

import {Flex} from '@shared_web/components/core2/flex';

import {AlertSymbol} from '@mavismart_frontend/components/alert_symbol';
import {Translate} from '@mavismart_frontend/components/translate';
import {useSearchResultContext} from '@mavismart_frontend/contexts/search_result_context';
import {formatSearchMatchesSubtitle} from '@mavismart_frontend/lib/door_search';
import {GenericCell} from '@mavismart_frontend/pages/cells/generic_cell';
import {getUserLanguage, useAccount} from '@mavismart_frontend/stores/account_store';

export const AdvancedSearchResults: FC = () => {
  const searchResult = useSearchResultContext();
  const results = searchResult?.results ?? [];
  const searchQuery = searchResult?.searchQuery ?? '';
  const {doorId: currentDoorId} = useParams<{doorId?: string}>();
  const account = useAccount();
  const lang = getUserLanguage(account);

  if (results.length === 0) {
    return (
      <Flex $column $align="center" $justify="center" $padding={['l', 's']}>
        <Translate value="no_doors_search_results" />
      </Flex>
    );
  }

  return (
    <Wrapper>
      {results.map(result => {
        const {door, matches} = result;
        const {id: doorId, label, status} = door;
        return (
          <GenericCell
            key={doorId}
            id={doorId}
            title={label ? `${label} - ${doorId}` : doorId}
            subtitle={formatSearchMatchesSubtitle({door, matches, searchQuery, lang})}
            to={`/search/${doorId}/info`}
            highlighted={doorId === currentDoorId}
            icon={<AlertSymbol level={status ?? 'green'} />}
          />
        );
      })}
    </Wrapper>
  );
};

AdvancedSearchResults.displayName = 'AdvancedSearchResults';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex-grow: 1;
  overflow: auto;
`;
